import { useTheme } from '@mui/material';

export const FaxIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
        >
            <rect x="8" y="8" width="24" height="20" rx="4" fill={primaryBackground} />
            <path
                d="M12 22.6667V26.6667C12 27.0203 12.1405 27.3594 12.3905 27.6095C12.6406 27.8595 12.9797 28 13.3333 28H22.6667C23.0203 28 23.3594 27.8595 23.6095 27.6095C23.8595 27.3594 24 27.0203 24 26.6667V24"
                stroke={primaryStroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.6667 10.6667H9.33333M4 21.3333V6.66667C4 6.31304 4.14048 5.97391 4.39052 5.72386C4.64057 5.47381 4.97971 5.33333 5.33333 5.33333H20V22.6667H5.33333C4.97971 22.6667 4.64057 22.5262 4.39052 22.2761C4.14048 22.0261 4 21.687 4 21.3333ZM21.3333 24H26.6667C27.0203 24 27.3594 23.8595 27.6095 23.6095C27.8595 23.3594 28 23.0203 28 22.6667V5.33333C28 4.97971 27.8595 4.64057 27.6095 4.39052C27.3594 4.14048 27.0203 4 26.6667 4H21.3333C20.9797 4 20.6406 4.14048 20.3905 4.39052C20.1405 4.64057 20 4.97971 20 5.33333V22.6667C20 23.0203 20.1405 23.3594 20.3905 23.6095C20.6406 23.8595 20.9797 24 21.3333 24Z"
                stroke={primaryStroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
